export enum InformationScope {
  Release = 'release',
  Delivery = 'delivery',
  Download = 'download',
  Announcement = 'announcement'
}
